import { createStyles } from "@mantine/styles";

export const useStyles = createStyles((theme) => ({
  sidebarContainer: {
    position: "relative",
    alignSelf: "flex-start",
    width: "350px",
    minWidth: "350px",
    transition: "width 200ms ease",
    borderRight: `1px solid ${theme.colors.gray[3]}`,

    "@media (max-width: 768px)": {
      width: "100%",
      minWidth: "100%",
      borderRight: "none",
      borderBottom: `1px solid ${theme.colors.gray[3]}`,
      marginBottom: "1rem",
    },
  },

  stickySidebar: {
    position: "sticky",
    top: "1rem",
    alignSelf: "flex-start",

    "@media (max-width: 768px)": {
      position: "static",
    },
  },

  scrollArea: {
    padding: "1rem",
    display: "flex",
    flexDirection: "column",

    "@media (max-width: 768px)": {
      padding: "1rem",
    },
  },

  yearSelect: {
    marginBottom: "1rem",

    "& .mantine-Select-input": {
      width: "100%",
    },
  },

  divider: {
    margin: "1rem 0",
  },

  sectionItem: {
    marginBottom: "0.5rem",
    cursor: "pointer",
    padding: "0.5rem",
    borderRadius: 4,
    transition: "background-color 0.2s ease, font-weight 0.2s ease",
    backgroundColor: "transparent",
    color: theme.colors.gray[7],

    "&:hover": {
      backgroundColor: theme.colors.blue[0],
      color: theme.colors.blue[7],
    },

    "&:focus-visible": {
      outline: `2px solid ${theme.colors.blue[5]}`,
      outlineOffset: 2,
    },
  },

  activeSection: {
    backgroundColor: theme.colors.blue[0],
    color: theme.colors.blue[7],
    fontWeight: 500,

    "&:hover": {
      backgroundColor: theme.colors.blue[0],
    },
  },

  documentItem: {
    marginBottom: "1.5rem",
    width: "100%",
  },

  documentHeader: {
    cursor: "pointer",
    userSelect: "none",
    transition: "all 0.2s ease",

    "&:hover": {
      opacity: 0.8,
    },

    width: "100%",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.xs,
  },

  documentLink: {
    display: "flex",
    gap: "0.5rem",
    cursor: "pointer",
    padding: "0.25rem 0",
    color: theme.colors.blue[6],
    textDecoration: "none",

    "&:hover": {
      textDecoration: "underline",
    },

    width: "100%",
  },

  documentContent: {
    paddingLeft: "0.5rem",
    transition: "max-height 0.2s ease",
    width: "100%",
  },

  documentTextContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    width: "100%",
    minWidth: 0,
  },
  documentLinkActive: {
    backgroundColor: theme.colors.blue[0], // sky blue background
    borderRadius: theme.radius.sm,
    padding: "0.2rem 0.25rem",
  },

  documentText: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    flex: 1,
    minWidth: 0,
  },

  chevron: {
    transition: "transform 0.2s ease",
    flexShrink: 0,
  },

  uploadContainer: {
    width: "100%",
    marginTop: "1rem",
    padding: "0.5rem 0",
  },
}));
